export default "__VITE_ASSET__CQVPhRjj__"